import { Field } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  requestTo,
} from "../../components/action-buttons/ActionButtonGenerator";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import TextInput from "../../components/form-fields/TextInput";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import MultiSelect from "../../components/form-fields/MultiSelect";
import { useTranslation } from "react-i18next"; /* Added Line */

export default function Groups(props) {
  const [showModal, setShowModal] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [refreshList, setRefreshList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [t, i18n] = useTranslation(); /* Added Line */

  const validationSchema = yup.object({
    nameTr: yup.string().required("Gerekli alan."),
    nameEN: yup.string().required("Gerekli alan."),
  });

  const arrangeBeforePersist = (values) => {
    let payload = {
      nameTr: values.nameTr,
      nameEN: values.nameEN,
      id: values.id,
      companyIds: values.companies,
      stId: values.stId || 90,
    };
    return payload;
  };

  const adaptDataForUpdate = (data) => {
    let adaptedData = {
      nameTr: data.nameTr,
      nameEN: data.nameEN,
      id: data.id,
      stId: data.stId,
      companies: data.companies.map((c) => c.id),
    };
    setInitialValues(adaptedData);
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const onAddButtonClicked = () => {
    setShowModal(true);
    setIsUpdating(false);
    setInitialValues({});
  };

  return (
    <Main>
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <CrudMain
            onAddButtonClicked={onAddButtonClicked}
            showModal={showModal}
            setShowModal={setShowModal}
            title={t("sidebar.sirketGruplari")}
          >
            <FormikForm
              isUpdating={isUpdating}
              entityId={selectedRow && selectedRow.id}
              entityFetchId="id"
              endPointUrl="company-group/create"
              fetchPointUrl="company-group/find"
              editPointUrl="company-group/update"
              configPointUrl="company-group/config"
              arrangeBeforePersist={arrangeBeforePersist}
              adaptDataForUpdate={adaptDataForUpdate}
              setConfigData={(data) => setConfigData(data)}
              initialValues={initialValues}
              validationSchema={validationSchema}
              closeModal={() => setShowModal(false)}
              refreshList={() => setRefreshList(!refreshList)}
            >
              <Field
                name="companies"
                label={t("groups.sirketler")}
                colNumber="12"
                component={MultiSelect}
                options={configData && configData.companies}
                // required
              />
              <Field
                name="nameTr"
                label={t("groups.grup")}
                colNumber="12"
                component={TextInput}
                required
              />
              <Field
                  name="nameEN"
                  label={t("groups.grupEn")}
                  colNumber="12"
                  component={TextInput}
                  required
                />
            </FormikForm>
          </CrudMain>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName="gruplar"
            endpoint="company-group/list-default"
            keyField="id"
            refreshList={refreshList}
            columns={[
              {
                dataField: "id",
                text: "ID",
                sort: true,
                headerClasses: "id-header",
              },
              {
                dataField: "nameTr",
                text: `${t("demandList.grupAdi")}`,
                sort: true,
                
              },
              {
                dataField: "nameEN",
                text: `${t("demandList.grupAdiEn")}`,
                sort: true,
              },
              {
                dataField: "statusName",
                text: `${t("demandList.durum")}`,
                sort: true,
              },
            ]}
            actionButtonsObject={{
              actions: [
                pushToParams(ABT.EDIT, onUpdateButtonClicked),
                requestTo(ABT.ACTIVE, "company-group/aktif-pasif"),
                requestTo(ABT.PASSIVE, "company-group/aktif-pasif"),
                /* requestTo(ABT.DELETE, "company-group/delete"), */
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}
